import { useLocation } from "react-router-dom";
import { getModuleConfig } from "../../config/modulePageConfig";
import SidebarCards from "./SidebarCards";
import styles from "./RightSidebar.module.css";

const RightSidebar = () => {
  const path = useLocation().pathname;
  const { sidebar } = getModuleConfig(path);

  return (
    <aside className={styles.rightSidebar}>
      <SidebarCards {...sidebar} />
    </aside>
  );
};

export default RightSidebar;

